import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CompanyInput from "../../Inputs/CompanyInput/CompanyInput";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../hooks/useNotifaction";
import { createCompany, getAllCompanies } from "../../../redux/companySlice/companySlice";

export default function AddCompany({ handleNewCompany }) {
  const location = useLocation();
  const isAddCompanyPage = location.pathname.endsWith("/AddCompany");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [companyData, setCompanyData] = useState({
    companyName: "",
    email: "",
    state: "",
    city: "",
    location: "",
    address: "",
    phone: "",
    commercialRecord: "123213213",
    taxNumber: "213123123",
  });

  const handleInputChange = (name, value) => {
    setCompanyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const { companyName, email, state, city, location, address, phone, commercialRecord, taxNumber } = companyData;

    if (!companyName) {
      notify("يرجى إدخال اسم الشركة", "error");
      return false;
    }

    if (!state) {
      notify("يرجى إدخال المحافظة", "error");
      return false;
    }
    if (!city) {
      notify("يرجى إدخال المدينة", "error");
      return false;
    }
    if (!location) {
      notify("يرجى إدخال الموقع", "error");
      return false;
    }
    if (!address) {
      notify("يرجى إدخال العنوان", "error");
      return false;
    }

    return true;
  };

  async function handleForm(e) {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      let companyPayload = {
        name: companyData.companyName,
        email: companyData.email,
        address: companyData.address,
        city: companyData.city,
        state: companyData.state,
        location: companyData.location,
        phone: companyData.phone,
        commercial_record: companyData.commercialRecord,
        tax_number: companyData.taxNumber,
      };

      companyPayload = Object.fromEntries(Object.entries(companyPayload).filter(([_, value]) => value !== "" && value !== null && value !== undefined));

      let res = await dispatch(createCompany(companyPayload)).unwrap();
      notify("تمت إضافة الشركة بنجاح", "success");
      if (isAddCompanyPage) {
        navigate("/companies");
      } else {
        handleNewCompany();
      }
      await dispatch(getAllCompanies());
      notify(res?.message, "success");
      setCompanyData({
        companyName: "",
        email: "",
        state: "",
        city: "",
        location: "",
        address: "",
        phone: "",
        commercialRecord: "123213213",
        taxNumber: "213123123",
      });
    } catch (error) {
      console.log(error);
      notify(error?.message, "error");
    }
  }

  return (
    <div className={isAddCompanyPage ? "main" : ""}>
      {isAddCompanyPage && <h2 className="text-white mb-4">اضافة شركة</h2>}
      <form onSubmit={handleForm}>
        <div className={isAddCompanyPage ? "card mb-3 pt-5 pb-2 px-3 companyProfile" : "mb-3 pt-5 pb-2 px-3 companyProfile"}>
          <CompanyInput companyData={companyData} onInputChange={handleInputChange} />
          <div>
            <button type="submit" className="btn btn-primary">
              <i className="fas fa-plus me-1"></i> اضافة
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
